export interface LegendProps {
    symbolHeight: number;
    symbolWidth: number;
    symbolRadius: number;
    itemStyle: {
        fontSize: string;
        fontWeight: string;
        color: string;
    };
    backgroundColor?: string;
    floating?: boolean;
    verticalAlign?: string;
    align?: string;
    width?: number;
    x?: number;
    y?: number;
    useHTML: boolean;
    layout?: string;
}

export const legendProperties: LegendProps = {
    symbolHeight: 14,
    symbolWidth: 14,
    symbolRadius: 0,
    itemStyle: {
        fontSize: '15px',
        fontWeight: 'normal',
        color: "#666"
    },
    backgroundColor: '#ffffff',
    align: 'right',
    verticalAlign: 'bottom',
    layout : "vertical",
    x: -24,
    y: -10,
    floating : true,
    useHTML: true
};
